// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanManagement_base--1wZLx"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/ClanManagement.scss
// module id = 2406
// module chunks = 11